/**
 *
 * @todo https://github.com/elkdanger/kanban-board-pwa/tree/master/src
 *
 */
/* eslint-disable no-console */

import { register } from 'register-service-worker'

//if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready () {
            // console.log(
            //     'App is being served from cache by a service worker.\n' +
            //     'For more details, visit https://goo.gl/AFskqB'
            // )

            // @TODO
            // initPush();

        },
        registered () {
            //console.log('Service worker has been registered.')
        },
        cached () {
            //console.log('Content has been cached for offline use.')
        },
        updatefound () {
            //console.log('New content is downloading.')
        },
        updated () {
            //console.log('New content is available; please refresh.')

            setTimeout(() => {
                window.location.reload(true)
            }, 1000)

        },
        offline () {
            //console.log('No internet connection found. App is running in offline mode.')
        },
        error (error) {
            //console.error('Error during service worker registration:', error)
        }
    })
//}


function initPush() {
    if (!navigator.serviceWorker.ready) {
        return;
    }

    new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    })
        .then((permissionResult) => {
            if (permissionResult !== 'granted') {
                throw new Error('We weren\'t granted permission.');
            }

            subscribeUser();
        });
}


function subscribeUser() {
    navigator.serviceWorker.ready
        .then((registration) => {
            const subscribeOptions = {
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(
                    'BE8GswcH3HWCrQNwUYOb4Ily3NPAsiMASvhvjksqDwA2T9NjwoGb9mOdllCdJT2eaYiTN_nTFN1ZD_X5fsW7o8U'
                )
            };

            return registration.pushManager.subscribe(subscribeOptions);
        })
        .then((pushSubscription) => {
            console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
            storePushSubscription(pushSubscription);
        });
}

function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


function storePushSubscription(pushSubscription) {
    //const token = document.querySelector('meta[name=csrf-token]').getAttribute('content');

    fetch(process.env.VUE_APP_API_URL_PUSH_SUBSCRIBE_POST, {
        method: 'POST',
        body: JSON.stringify(pushSubscription),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            //'X-CSRF-Token': token
        }
    })
        .then((res) => {
            return res.json();
        })
        .then((res) => {
            console.log(res)
        })
        .catch((err) => {
            console.log(err)
        });
}
